import {
  BUTTON_FONT_WEIGHT,
  BUTTON_PRIMARY_BG,
  DEFAULT_BUTTON_SIZE,
  createDefaultButtonChrome,
  resolveButtonSizeFontSize,
} from "./button-presentation";
import { BLOCK_PADDING, uid } from "../create-shared";
import type {
  ButtonChrome,
  ButtonRowBlock,
  ButtonRowSlot,
  ButtonSizing,
  EmailSettings,
} from "../types";
import type { BlockDefinition } from "./types";

const DEFAULT_BUTTON_LABEL = "Click here";

function createDefaultButtonSizing(): ButtonSizing {
  return {
    fontSize: resolveButtonSizeFontSize(DEFAULT_BUTTON_SIZE),
    fontWeight: BUTTON_FONT_WEIGHT,
    size: DEFAULT_BUTTON_SIZE,
  };
}

function createButtonRowSlot(
  label: string,
  overrides?: Partial<ButtonChrome & ButtonSizing & { fullWidth?: boolean }>,
): ButtonRowSlot {
  const defaults = createDefaultButtonChrome();
  return {
    label,
    href: "",
    ...defaults,
    ...createDefaultButtonSizing(),
    fullWidth: false,
    ...overrides,
  };
}

export function createButtonRowBlock(
  settings?: Pick<EmailSettings, "buttonFillColor">,
): ButtonRowBlock {
  const outlineColor = settings?.buttonFillColor ?? BUTTON_PRIMARY_BG;
  return {
    id: uid(),
    type: 'buttonRow',
    buttons: [
      createButtonRowSlot(DEFAULT_BUTTON_LABEL),
      createButtonRowSlot(DEFAULT_BUTTON_LABEL, {
        backgroundColor: 'transparent',
        color: outlineColor,
        borderColor: outlineColor,
        borderWidth: 2,
      }),
    ],
    align: 'left',
    gap: 12,
    stackOnMobile: true,
    stackFullWidth: true,
    padding: { ...BLOCK_PADDING },
  };
}

export const buttonRowBlockDefinition: BlockDefinition = {
  type: 'buttonRow',
  label: 'Button row',
  create: createButtonRowBlock,
};
